// src/redux/slices/filterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const filterSlice = createSlice({
  name: "filters",
  initialState: {
    startDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"), // 1 month back
    endDate: dayjs().format("YYYY-MM-DD"), // Current date
    startTime: dayjs().startOf("day").format("HH:mm:ss"), // Start of the day
    endTime: dayjs().format("HH:mm:ss"), // Current time
    dashboardClicked: 0,
    isEditAlertDone: false,
    page: 1,
    limit: 10,
    tablePagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      total: 0,
    },
  },
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = dayjs(action.payload).format("YYYY-MM-DD");
    },
    setEndDate: (state, action) => {
      state.endDate = dayjs(action.payload).format("YYYY-MM-DD");
    },
    setStartTime: (state, action) => {
      state.startTime = action.payload;
    },
    setEndTime: (state, action) => {
      state.endTime = action.payload;
    },
    setDashboardClicked: (state, action) => {
      state.dashboardClicked = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setTablePagination: (state, action) => {
      state.tablePagination.current = action.payload.current;
      state.tablePagination.pageSize = action.payload.pageSize;
      state.tablePagination.total = action.payload.total;
    },
    setIsEditAlertDone: (state, action) => {
      state.isEditAlertDone = action.payload;
    },
    resetFilters: (state) => {
      state.startDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
      state.endDate = dayjs().format("YYYY-MM-DD");
      state.startTime = dayjs().startOf("day").format("HH:mm:ss");
      state.endTime = dayjs().format("HH:mm:ss");
      state.dashboardClicked = 0;
      state.page = 0;
      state.limit = 10;
      state.isEditAlertDone = false;
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setStartTime,
  setEndTime,
  setDashboardClicked,
  resetFilters,
  setPage,
  setLimit,
  setTablePagination,
  setIsEditAlertDone,
} = filterSlice.actions;

export default filterSlice.reducer;
